/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We use a phonetic heuristic: vowel groups are counted and common silent endings (like a trailing 'e') are removed. It's accurate for most English words, though some unusual words may differ by one.`)
};

const es_syl_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usamos una heurística fonética: se cuentan los grupos vocálicos y se eliminan las terminaciones mudas habituales (como una 'e' final). Es precisa para la mayoría de las palabras en inglés, aunque algunas palabras poco comunes pueden diferir en una sílaba.`)
};

const de_syl_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir verwenden eine phonetische Heuristik: Vokalgruppen werden gezählt, und häufige stumme Endungen (wie ein abschließendes 'e') werden entfernt. Das ist bei den meisten englischen Wörtern genau, auch wenn einzelne ungewöhnliche Wörter um eins abweichen können.`)
};

const nl_syl_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We gebruiken een fonetische heuristiek: klinkergroepen worden geteld en veelvoorkomende stomme uitgangen (zoals een slot-'e') worden verwijderd. Dit is nauwkeurig voor de meeste Engelse woorden, al kunnen sommige ongebruikelijke woorden één lettergreep afwijken.`)
};

const fr_syl_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous utilisons une heuristique phonétique : les groupes de voyelles sont comptés et les terminaisons muettes courantes (comme un 'e' final) sont supprimées. C'est précis pour la plupart des mots anglais, bien que certains mots inhabituels puissent varier d'une syllabe.`)
};

const it_syl_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usiamo un'euristica fonetica: vengono contati i gruppi di vocali e vengono rimosse le desinenze mute comuni (come una 'e' finale). È accurata per la maggior parte delle parole inglesi, anche se alcune parole insolite possono differire di una sillaba.`)
};

const pt_br2_syl_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usamos uma heurística fonética: os grupos de vogais são contados e as terminações mudas comuns (como um 'e' final) são removidas. É precisa para a maioria das palavras em inglês, embora algumas palavras incomuns possam diferir em uma sílaba.`)
};

const pt_syl_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizamos uma heurística fonética: os grupos de vogais são contados e as terminações mudas comuns (como um 'e' final) são removidas. É precisa para a maioria das palavras inglesas, embora algumas palavras invulgares possam diferir por uma sílaba.`)
};

const ja_syl_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音声的なヒューリスティックを使用しています。母音グループをカウントし、語末の無音の「e」のようによくある無音の語尾を除去します。ほとんどの英単語では正確ですが、珍しい単語では1音節ほど異なる場合があります。`)
};

const zh_syl_hub_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们采用语音启发式算法：统计元音组，并去除常见的不发音结尾（如结尾的字母“e”）。这种方法对大多数英语单词都很准确，不过部分不常见的单词可能会有一个音节的误差。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_hub_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_hub_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_hub_faq1_a", locale)
	if (locale === "en") return en_syl_hub_faq1_a(inputs)
	if (locale === "es") return es_syl_hub_faq1_a(inputs)
	if (locale === "de") return de_syl_hub_faq1_a(inputs)
	if (locale === "nl") return nl_syl_hub_faq1_a(inputs)
	if (locale === "fr") return fr_syl_hub_faq1_a(inputs)
	if (locale === "it") return it_syl_hub_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_syl_hub_faq1_a(inputs)
	if (locale === "pt") return pt_syl_hub_faq1_a(inputs)
	if (locale === "ja") return ja_syl_hub_faq1_a(inputs)
	return zh_syl_hub_faq1_a(inputs)
};